import messages from './messages.json';

const localeEn = {
    code: 'en',
    messages: messages,
};

export default localeEn;